import React, { useState } from 'react';
import { Link } from 'react-router-dom';

interface NavbarProps {
  onDonateClick: (e: React.MouseEvent) => void;
}

const Navbar: React.FC<NavbarProps> = ({ onDonateClick }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };
  return (
    <header className="gm-header">
      {/* Top Stats Bar */}
      <div className="gm-stats-bar">
        <div className="container">
          <div className="gm-stats-content">
            <div className="gm-stats-left">
              4 284 087 LIVES PROTECTED
            </div>
            <div className="gm-stats-right">
              EVERY R75/$4.50 SPENT PROTECTS A LIFE
            </div>
            
            {/* Mobile Burger Menu Button */}
            <button 
              className={`gm-mobile-menu-toggle ${isMobileMenuOpen ? 'menu-open' : ''}`}
              onClick={toggleMobileMenu}
              aria-label="Toggle mobile menu"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </div>
      </div>

      {/* Logo Section */}
      <div className="gm-logo-section">
        <div className="container">
          <Link to="/" className="gm-logo">
            <img src="/images/GBM-Lockup-Logos-05.png" alt="Goodbye Malaria" />
          </Link>
        </div>
      </div>

      {/* Navigation Links */}
      <div className="gm-nav-section gm-header-bottom">
        <div className="container">
          <nav className="gm-nav-links">
            <ul>
              <li><a href="https://shop.goodbyemalaria.com/collections/apparel">APPAREL</a></li>
              <li><a href="https://shop.goodbyemalaria.com/collections/childrens-clothing">KIDDIES CORNER</a></li>
              <li><a href="https://shop.goodbyemalaria.com/collections/accessories">ACCESSORIES</a></li>
              <li><a href="https://shop.goodbyemalaria.com/collections/home">HOMEWARE</a></li>
              <li><a href="https://shop.goodbyemalaria.com/pages/corporate-gifting">CORPORATE</a></li>
              <li><a href="https://shop.goodbyemalaria.com/collections/goodbye-deals">GOOD BUYS</a></li>              
              <li><a href="https://donate.goodbyemalaria.com/customer/givenow" onClick={onDonateClick} className="gm-give-now">GIVE NOW</a></li>
            </ul>
          </nav>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <div className="gm-mobile-menu-overlay" onClick={closeMobileMenu}>
          <div className="gm-mobile-menu-content" onClick={(e) => e.stopPropagation()}>
            <button className="gm-mobile-menu-close" onClick={closeMobileMenu}>
              ×
            </button>
            <nav className="gm-mobile-nav">
              <ul>
                <li><a href="https://shop.goodbyemalaria.com/collections/apparel" onClick={closeMobileMenu}>APPAREL</a></li>
                <li><a href="https://shop.goodbyemalaria.com/collections/childrens-clothing" onClick={closeMobileMenu}>KIDDIES CORNER</a></li>
                <li><a href="https://shop.goodbyemalaria.com/collections/accessories" onClick={closeMobileMenu}>ACCESSORIES</a></li>
                <li><a href="https://shop.goodbyemalaria.com/collections/home" onClick={closeMobileMenu}>HOMEWARE</a></li>
                <li><a href="https://shop.goodbyemalaria.com/pages/corporate-gifting" onClick={closeMobileMenu}>CORPORATE</a></li>
                <li><a href="https://shop.goodbyemalaria.com/collections/goodbye-deals" onClick={closeMobileMenu}>GOOD BUYS</a></li>
                <li>
                  <a 
                    href="https://donate.goodbyemalaria.com/customer/givenow" 
                    onClick={(e) => {
                      closeMobileMenu();
                      onDonateClick(e);
                    }} 
                    className="gm-give-now"
                  >
                    GIVE NOW
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
